import { CSSProperties, FC } from "react";

import styles from "./styles.module.scss";

interface IProps {
    width: number | string;
    height: number | string;
    margin?: number | string;
    borderRadius?: number | string;
    waveWidth?: number;
}

const Skeleton: FC<IProps> = ({ width, height, margin = 0, borderRadius = "8px", waveWidth = 200 }) => {
    return (
        <div
            className={styles.skeleton}
            style={
                {
                    "--waveWidth": waveWidth + "px",
                    width,
                    height,
                    margin,
                    borderRadius,
                } as CSSProperties
            }
        />
    );
};

export default Skeleton;
